import { HttpErrorResponse, HttpRequest } from '@angular/common/http'
import * as Sentry from '@sentry/angular'

export function captureHttpError(error: HttpErrorResponse, req: HttpRequest<unknown>): void {
	const isNetworkError: boolean = error.status === 0
	const { url, method, headers, body } = req

	const safeHeaders: Record<string, string> = headers
		.keys()
		.reduce((acc: Record<string, string>, key: string): Record<string, string> => {
			if (key.toLowerCase() !== 'authorization') {
				acc[key] = headers.get(key) ?? ''
			}
			return acc
		}, {})

	const sentryError = new Error(
		isNetworkError
			? `[NETWORK ERROR] ${method} ${url} — no response (CORS, timeout, offline)`
			: `[${method}] ${url} → ${error.status} ${error.statusText || ''}`,
	)

	Sentry.captureException(sentryError, {
		tags: { url, method, status: error.status, network: isNetworkError },
		extra: {
			request: { url, method, headers: safeHeaders, body },
			response: error.error,
			errorMessage: error.message,
			errorName: error.name,
			errorUrl: error.url,
			originalStatus: error.status,
		},
	})
}
